import React from 'react';
import styles from './CardCategory.module.scss';
import { CardProps } from '../M20Categories';
import { useEvents } from '~/shared/hooks/useEvents';
import { usePathname } from 'next/navigation';
import { useFrame } from '~/shared/utils';
import { useUtils } from '~/shared/hooks/useUtils';
import { Category } from '~/lib/data-contract';
import { Image, Link, Text } from '~/shared/components';
import { AlignContent } from '../../AlignContent';

export const CardCategory = ({
    item,
    priority,
    dataid,
    hitsResults,
    desktopAspectRatio,
    tabletAspectRatio,
}: CardProps) => {
    const { target, url } = item.callToAction || {};
    const pathname = usePathname();
    const isOfferPage = pathname?.includes('tilbudsavis');
    const { data } = useFrame();
    const { overlaySearchClickEvent } = useEvents(data);
    const { getHostName } = useUtils();

    const handleClick = (item: Category) => {
        overlaySearchClickEvent({
            search_term: hitsResults?.query ?? '',
            number_of_results: hitsResults?.nbHits,
            search_url: window.location.href,
            destination_url: `${getHostName()}${item?.callToAction?.url}`,
            type_of_result: 'Other shortcuts',
        });
    };

    return (
        <div
            className={styles.cardContainer}
            data-testid={isOfferPage ? `offer-item-${dataid}` : null}
            style={
                {
                    ['--desktop-aspect-ratio']: desktopAspectRatio,
                    ['--tablet-aspect-ratio']: tabletAspectRatio,
                } as React.CSSProperties
            }
        >
            <Link
                className={styles.link}
                aria-label={item.headline?.text || 'Card Link'}
                onClick={() => handleClick(item)}
                href={url}
                noHover
                target={target}
            >
                {item.image?.src && (
                    <div className={styles.cardImageWrapper}>
                        <Image
                            priority={priority}
                            {...item.image}
                            alt={item.imageAltText || item.image.name}
                            layout="fill"
                            objectFit="cover"
                        />
                    </div>
                )}

                {(item.headline?.text ||
                    item.subHeadline?.text ||
                    item.subSubHeadline?.text ||
                    item.title) && (
                    <div className={styles.cardContent}>
                        <AlignContent
                            alignment={item.horizontalAlignment}
                            position={item.verticalAlignment}
                            textColor={item.textColor}
                        >
                            {item.headline?.text ? (
                                <Text
                                    children={item.headline.text}
                                    color={item.headline.textColor || item.textColor}
                                    as={item.headline.tag}
                                    variant={item.headline.style}
                                />
                            ) : null}
                            {item.subHeadline?.text ? (
                                <Text
                                    children={item.subHeadline.text}
                                    color={item.subHeadline.textColor || item.textColor}
                                    as={item.subHeadline.tag}
                                    variant={item.subHeadline.style}
                                />
                            ) : null}
                            {item.subSubHeadline?.text ? (
                                <Text
                                    children={item.subSubHeadline.text}
                                    color={item.subSubHeadline.textColor || item.textColor}
                                    as={item.subSubHeadline.tag}
                                    variant={item.subSubHeadline.style}
                                />
                            ) : null}{' '}
                            {item.title ? (
                                <p className={styles.title} style={{ color: item.textColor }}>
                                    {item.title}
                                </p>
                            ) : null}
                        </AlignContent>
                    </div>
                )}
            </Link>
        </div>
    );
};
